"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ id: "tube_svg__Layer_1", xmlns: "http://www.w3.org/2000/svg", x: 0, y: 0, width: "1em", height: "1em", viewBox: "0 0 14 32", xmlSpace: "preserve", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("style", null, '.tube_svg__st0{fill-rule:evenodd;clip-rule:evenodd}'),
        React.createElement("path", { className: "tube_svg__st0", d: "M9.745 10.496l-2.563.512 1.739-5.124-5.374 5.852 2.562-.513-1.739 5.125z" }),
        React.createElement("path", { className: "tube_svg__st0", d: "M13.4 18.118c0-.008-.181-.016-.493-.022v-9.07c0-1.689-.492-3.218-1.32-4.406-.059-.085-.124-.162-.186-.243a6.263 6.263 0 00-.822-.881 5.62 5.62 0 00-.549-.428 5.347 5.347 0 00-1.573-.745 5.228 5.228 0 00-1.438-.208c-.594 0-1.164.104-1.701.288-1 .343-1.883.976-2.576 1.829-.692.849-1.188 1.913-1.435 3.105a8.294 8.294 0 00-.177 1.689V18.098c-.339.007-.533.014-.533.023-.382.415-.597.984-.597 1.763V24.4h1.547v3.985a.5.5 0 001 0V24.4h1.5v2.985a.5.5 0 001 0V24.4h1.5v4.985a.5.5 0 001 0V24.4h1.5v2.985a.5.5 0 001 0V24.4h1.5v3.985a.5.5 0 001 0V24.4H14v-4.515c0-.782-.216-1.352-.6-1.767zm-11.271-.632V9.026c0-.486.053-.986.156-1.486.211-1.021.637-1.947 1.23-2.677.58-.712 1.315-1.235 2.126-1.513a4.256 4.256 0 011.377-.234c.383 0 .764.055 1.164.17.453.129.884.333 1.282.607a5.065 5.065 0 011.144 1.094l.068.087c.031.039.062.077.091.119.746 1.071 1.14 2.397 1.14 3.835v9.056c-2.45-.023-7.3-.022-9.778.002v-.6z" })));
};
var SvgTube = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgTube;
var templateObject_1;
